import { changeHouse, changeStreet } from './actionTypes';

export const addressReducer = (state, action) => {
  switch (action.type) {
    case changeStreet: {
      return {
        street: action.payload,
        house: undefined,
      };
    }
    case changeHouse: {
      return { ...state, house: action.payload };
    }
    default: {
      return state;
    }
  }
};
